import { render, staticRenderFns } from "./DataTableExpansionPanelMobile.vue?vue&type=template&id=ed946a54&scoped=true&"
import script from "./DataTableExpansionPanelMobile.vue?vue&type=script&lang=js&"
export * from "./DataTableExpansionPanelMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed946a54",
  null
  
)

export default component.exports